export class Player {
  constructor(identifier, name, coefficient, goalkeeper) {
    this.identifier = identifier;
    this.name = name;
    this.coefficient = coefficient;
    this.goalkeeper = goalkeeper;
  }
}
